function Spacer({ space }) {
  return <div style={{ marginTop: space + "vh" }} />;
}

export default Spacer;
